import {
    PORT_LIST_GET,
    PORT_LIST_GET_F,
    PORT_LIST_GET_R,
    PORT_SELECTED_SET
}  from '../actionType'

const initialState = {
    ports: [],
    isLoading: false,
    error: null,
    selectedPorts: null,
    totalPage: 0,
    totalElement: 0,
}

export default function PortReducer (state = initialState, action:any)  {
    switch(action.type) {
        case PORT_LIST_GET:
            return {
                ...state,
                isLoading: true,
                error: null
            } 
        case PORT_LIST_GET_F:
            return {
                ...state,
                isLoading: false,
                ports: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case PORT_LIST_GET_R:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case PORT_SELECTED_SET:
            return {
                ...state,
                selectedPorts: action.payload
            }
        default:
            return state
    }
}